import React from 'react';
import ReactEcharts from 'echarts-for-react'
import PropTypes from 'prop-types';
import NHFetch from '../../../../utils/NHFetch';

import styles from '../styles.css';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 5 * 1000; //轮询时间间隔

/**
 * 顶部统计板块
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-09-30
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            errCount: 0, //连续请求错误次数
            data: {}, //报到统计数据
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 获取报到统计数据
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/rlsb/getStatisticsForReported', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: 0, data: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    }

    /**
     * * 构造饼图参数
     * @memberof IndexComponent
     */
    getOption = () => {
        const rem=window.rem;
        const {faceNum = 0, otherNum = 0, unreportedNum = 0 } = this.state.data;
        const option = {
            tooltip: {
                trigger: 'item',
                formatter: "{b} : {c} ({d}%)"
            },
            legend: {
                orient: 'horizontal',
                x : 'left',
                y : 'bottom',
                padding:[0,0.3*rem],
                itemGap: 0.1*rem,
                itemWidth:0.15*rem,
                data: [
                    {
                        name: '刷脸报到数',
                        icon: 'rect',
                    },
                    {
                        name: '其他报到数',
                        icon: 'rect',
                    },
                    {
                        name: '未报到数',
                        icon: 'rect',
                    }
                ],
                textStyle: {
                    color: '#00ccff',
                    height: 0.3*rem,
                    lineHeight: 0.3*rem,
                }
            },
            series: [
                {
                    name: '半径模式',
                    type: 'pie',
                    radius: [0, 0.57 *rem],
                    center: ['49%', '46%'],
                   /* roseType: 'radius',*/
                    itemStyle: {
                        normal: {
                            label: {
                                show: true,
                                formatter: '{hb|{b}: {c}} ({d}%)',
                                height: 0.30 * rem,
                                color: '#00ccff',
                                rich: {
                                    hb: {
                                        height: 0.1 *rem,
                                        color: '#00ccff',
                                    },
                                }
                            },
                            labelLine: {
                                show: true,
                                length:0.09*rem,
                                length2:0.10*rem,
                            },
                        }
                    },
                    data: [{
                        value: faceNum || 0,
                        name: '刷脸报到数',
                        itemStyle: {
                            normal: {
                                color: {
                                    colorStops: [{
                                        offset: 0,
                                        color: '#0771f9' // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: '#5bf7b6' // 100% 处的颜色
                                    }]
                                },
                            }
                        }
                    },
                    {
                        value: otherNum || 0,
                        name: '其他报到数',
                        itemStyle: {
                            normal: {
                                color: {
                                    colorStops: [{
                                        offset: 0,
                                        color: '#63d745' // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: '#c0e85a' // 100% 处的颜色
                                    }]
                                },
                            }
                        }
                    },
                    {
                        value: unreportedNum || 0,
                        name: '未报到数',
                        itemStyle: {
                            normal: {
                                color: {
                                    colorStops: [{
                                        offset: 0,
                                        color: '#fd4d40' // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: '#edbb46' // 100% 处的颜色
                                    }]
                                },
                            }
                        }
                    }
                    ],

                }
            ]
        };
        return option;
    }

    /**
     * * 分割数字
     *
     * @memberof IndexComponent
     */
    spiltNum = (num, numArray) => {

        if (parseInt(num / 10) == 0) {
            numArray.push(num);
            return;
        }

        let wholeNumber = parseInt(num / 10);
        let remainder = num % 10;

        numArray.push(remainder);

        this.spiltNum(wholeNumber, numArray);

    }

    render() {
        const { totalNum = 0} = this.state.data;
        let numArray = [];

        //分割数字
        this.spiltNum(totalNum, numArray);

        let spanArray = [];
        for (let i = 0; i < 5; i++) {

            if (i < numArray.length) {
                spanArray.push(<span key={i}>{numArray[i]}</span>);
            } else {
                spanArray.push(<span key={i}>0</span>);
            }
        }

        spanArray.reverse();

        return (
            <div>
                <div className={styles.totalNum}>
                    {spanArray.map(item => item)}
                </div>
                <div className={styles.roseTable} style={{padding:0}}>
                        <ReactEcharts
                            option={this.getOption()}
                            style={{ width: '100%', height: '100%',}}
                        />
                </div>
            </div>
        )
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./components/face/scan/rightBox/top.js